// extracted by mini-css-extract-plugin
module.exports = {"floatingImages":"WorkHeroImages-module--floatingImages--2XoIt","leftImage":"WorkHeroImages-module--leftImage--i_S4q","rightImage":"WorkHeroImages-module--rightImage--CyUaq"};